import React from 'react';
import AppointmentForm from '../../AppointmentForm';

export default function AppointmentSection({
  sectionTitle,
  sectionTitleUp,
  imgUrl,
}) {
  return (
    <section className="bg-white py-16 md:py-24 relative overflow-hidden" id="appointment">
      {/* Decorative Background Shape */}
      <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-cream-dark/50 opacity-40 mix-blend-multiply pointer-events-none blur-3xl"></div>
      
      <div className="max-w-[1200px] mx-auto px-6 md:px-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          <div>
            <div className="inline-flex items-center gap-[0.6rem] text-[0.72rem] tracking-[0.2em] uppercase text-gold font-medium mb-4">
              <span className="w-[24px] h-px bg-gold block"></span>
              {sectionTitleUp || "Appointment"}
            </div>
            <h2 className="font-serif text-[2rem] md:text-[3.5rem] font-light leading-[1.2] text-charcoal mb-8 md:mb-10">
              {sectionTitle || "Book an Appointment"}
            </h2>
            <AppointmentForm />
          </div>
          <div className="hidden lg:block text-right">
            <div className="relative inline-block w-full max-w-[500px]">
               <div className="absolute -inset-4 border border-crimson rounded-md opacity-20 pointer-events-none"></div>
               <img src={imgUrl} alt="Appointment" className="rounded-md w-full h-auto object-cover relative z-10 shadow-2xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
